import Status from '../../enums/Status';
import {SET_CREATE_ACCOUNT_STATUS, UPDATE_CREATE_ACCOUNT_DETAILS} from '../actions/action-types';

const initialState = () => {
  const isNewGuestUpdatedPage = window.start?.settings?.is_new_guest_updated_page;
  
  return {
    fullName: window.start.order?.deliveryAddress?.addressee || '',
    password: '',
    status: isNewGuestUpdatedPage ? Status.STARTED : Status.NOT_STARTED,
  };
};

const createAccountReducer = (state = initialState(), action) => {
  switch (action.type) {
    case UPDATE_CREATE_ACCOUNT_DETAILS:
      return {
        ...state,
        [action.fieldName]: action.fieldValue,
      };
    case SET_CREATE_ACCOUNT_STATUS:
      return {
        ...state,
        status: action.status,
      };
    default:
      return state;
  }
};

export default createAccountReducer;
